import { Link } from "react-router-dom";

function Navbar() {
  return (
    <>
    <nav class="py-2 bg-light">
      <div class="container d-flex flex-wrap">
        <ul class="nav me-auto">
          <li class="nav-item"><Link to={`home`} class="nav-link link-dark px-2 active" aria-current="page">Home</Link></li>
          <li class="nav-item"><Link to={`accessions`} class="nav-link link-dark px-2">Accessions</Link></li>
          <li class="nav-item"><Link to={`graph`} class="nav-link link-dark px-2">Graph</Link></li>
          <li class="nav-item"><Link to={`pangenome`} class="nav-link link-dark px-2">Pangenome</Link></li>
          <li class="nav-item"><Link to={`diamond`} class="nav-link link-dark px-2">Diamond</Link></li>
          <li class="nav-item"><Link to={`sequences`} class="nav-link link-dark px-2">Sequences</Link></li>
          <li class="nav-item"><Link to={`variants`} class="nav-link link-dark px-2">Variants</Link></li>
          <li class="nav-item"><Link to={`map`} class="nav-link link-dark px-2">Map</Link></li>
          <li class="nav-item"><Link to={`about`} class="nav-link link-dark px-2">About</Link></li>
        </ul>
      </div>
    </nav>
    </>
  );
}

export default Navbar;
